<template>
  <v-card>
    <v-card-title primary-title>
      <div class="headline amber--text">{{title}}</div>
    </v-card-title> 
    <v-container>
      <v-layout row wrap px-3>
        <v-flex xs12 text-xs-center style="margin-top: -24px;">
          <span class="grey--text" v-html="loadingText"></span>
        </v-flex>
        <v-flex xs12 mb-3>
          <v-autocomplete
            :loading="loading_customer_autocomplete"
            :items="customersSelect"
            :search-input.sync="search_customers"
            v-model="record_info.customer_id"
            cache-items
            hide-no-data
            hide-details
            label="Cliente"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="record_info.maker"
            label="Fabricante"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="record_info.model"
            label="Modelo"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="record_info.year"
            label="Ano"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="record_info.plate"
            label="Placa"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            label="Anotações"
            auto-grow
            rows="1"
            v-model="record_info.notes"></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="white" class="grey--text" @click="$router.go(-1)">Cancelar</v-btn>
      <v-btn color="amber darken-3" dark @click="saveRecord()">{{saveBtnLabel}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  name: "CarForm",
  components: { },
  props: {
    record: Object
  },
  data() {
    return {
      record_info: {},
      loading: false,
      loading_customer_autocomplete: false,
      customers: [],
      search_customers: '',
      search_customers_interval: null,
      last_search_customer_val: ''
    }
  },
  computed: {
    customersSelect() {
      return this.customers.map(c => { return {text: c.name, value: `${c.id}`} })
    },
    loadingText() {
      return this.loading ? 'Carregando...' : '&nbsp;'
    },
    title() {
      return this.updateState ? 'Cadastro do Carro' : 'Cadastrar Carro'
    },
    carId() {
      const route_check_result = pathToRegexp('/carros/:id*').exec(this.$route.path)
      return route_check_result === null ? null : route_check_result[1];
    },
    updateState() {
      return this.carId ? (this.carId === 'novo' ? false : true) : false
    },
    saveBtnLabel() {
      return (this.updateState) ? 'Atualizar' : 'Salvar'
    }
  },
  watch: {
    search_customers(val) {
      if (val && val !== this.last_search_customer_val) {
        this.last_search_customer_val = val
        this.clearAutocompleteInterval()
        this.search_customers_interval = setTimeout(()=>{ this.queryCustomers(val) }, 500)
      }
    }
  },
  methods: {
    customerFor(customer_id) {
      return this.items_customers[customer_id] ? this.items_customers[customer_id].name : ''
    },
    clearAutocompleteInterval() {
      if (this.search_customers_interval !== null) { clearInterval(this.search_customers_interval) }
    },
    queryCustomers (v) {
      this.loading_customer_autocomplete = true

      let successCallback = (response) => {
        if (response.body.data) {
          this.loading_customer_autocomplete = false
          this.customers = response.body.data
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      let before = (request) => {
        if (this.previousRequest) { this.previousRequest.abort(); }
        this.previousRequest = request;
      }
      
      let params  = { s: v }
      let headers = { Token: this.$cookies.get('api_token') }

      this.$http.get(`${this.$root.base_url}/customers/search`, { before, params, headers }).then(successCallback, errorCallback)
    },
    checkRoute(string_route) {
      return pathToRegexp(string_route).exec(this.$route.path) !== null;
    },
    saveRecord() {
      let successCallback = (response) => {
        this.$router.go(-1)
      }

      let errorCallback = (response) => {
        debugger
      }

      let payload = {
        customer_id: this.record_info.customer_id,
        maker: this.record_info.maker,
        model: this.record_info.model,
        year: this.record_info.year,
        plate: this.record_info.plate,
        notes: this.record_info.notes,
      }

      if (this.updateState) {
        this.$http.put(`${this.$root.base_url}/cars/${this.carId}`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      } else {
        this.$http.post(`${this.$root.base_url}/cars`, payload, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
      }
    },
    loadRecord() {
      this.loading = true

      let successCallback = (response) => {
        if (response.body.data) {
          this.loading = false
          this.record_info = response.body.data[0]
          let customer_id = this.record_info.customer_id
          let customer = response.body.customers[customer_id]
          this.customers = [{id: customer_id, name: customer.name}]
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$http.get(`${this.$root.base_url}/cars/${this.carId}`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    }
  },
  created() {
    this.record_info = this.record
    if (this.record.customer_name) {
      this.customers = [{id: this.record.customer_id, name: this.record.customer_name}]
    }
    if (typeof this.record.id !== 'undefined') {
      this.loading = false
    }
  },
  destroyed() {
    this.clearAutocompleteInterval()
  },
  mounted() {
    if ((this.carId) && (typeof(this.record_info.id) === 'undefined')) {
      this.loadRecord()
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mecanica/CarForm.vue